<template>
  <div id="themeHead" :style="{ backgroundColor: props.currentTheme.theme_color || 'none' }">
    <div class="head-content">
      <div class="titles">
        <div class="learning-title">{{ props.currentLearningType.name }}</div>
        <div class="separater">—</div>
        <div class="theme-title">{{ props.currentTheme.name }}</div>
      </div>

      <!-- Theme opearation -->
      <div class="theme-operation">
        <!-- Modules -->
        <div :class="{ 'icon-btn': true, active: moduleActive }">
          <div
            :class="{ 'icon-btn-svg': true, clickable: !moduleActive }"
            @click="goTopicList"
            @keypress.enter="goTopicList"
          >
            <inline-svg class="svg-icon" :src="$assets.svg['theme-module-btn-2']" width="100%" height="100%" />
          </div>
          <p>Modules</p>
        </div>

        <!-- Guide -->
        <div :class="{ 'icon-btn': true, disabled: !themeGuides }">
          <div :class="{ 'icon-btn-svg': true, clickable: themeGuides }" @click="openGuide" @keypress.enter="openGuide">
            <inline-svg class="svg-icon" :src="$assets.svg['theme-guide-btn-2']" width="100%" height="100%" />
          </div>
          <p>
            Theme Guide
            <span v-if="!themeGuides" v-html="'<br />Coming Soon'" />
          </p>
        </div>

        <!-- Video -->
        <div class="icon-btn disabled">
          <div class="icon-btn-svg">
            <inline-svg class="svg-icon disabled" :src="$assets.svg['theme-video-btn-2']" width="100%" height="100%" />
          </div>
          <p>Videos<br />Coming Soon</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import $assets from '@/assets';
import $path from '@/utils/path';

const props = defineProps({
  currentLearningType: {
    type: Object,
    default: () => ({}),
  },
  currentTheme: {
    type: Object,
    default: () => ({}),
  },
});

const $route = useRoute();
const $router = useRouter();

const themeGuides = computed(() => {
  if (!props.currentTheme.guides) {
    return null;
  }

  const parsedObj = JSON.parse(props.currentTheme.guides);
  const languages = Object.keys(parsedObj);
  const items = languages.map((l) => ({
    language: l,
    src: $path.resolveFile(parsedObj[l]),
  }));

  return items.length > 0 ? items : null;
});

const moduleActive = computed(() => {
  return ['topicList', 'moduleList'].includes($route.name);
});

function openGuide() {
  if (!themeGuides.value) {
    return;
  }

  window.open(themeGuides.value[0].src, '_blank');
}

function goTopicList() {
  if (moduleActive.value) {
    return;
  }

  $router.push({
    name: 'topicList',
    params: { themeId: props.currentTheme.id },
  });
}
</script>
